import type { TripPhase } from '../hooks/useTripPhase'
import { cn } from '../lib/cn'

const STYLES: Record<TripPhase, { label: string; className: string; dot?: boolean }> = {
  planning: { label: 'Planning', className: 'bg-st-surface-2 text-st-muted' },
  upcoming: { label: 'Upcoming', className: 'bg-st-sky/20 text-st-primary-700' },
  live: { label: 'Live now', className: 'bg-st-accent/15 text-st-accent-700', dot: true },
  completed: { label: 'Completed', className: 'bg-st-primary/12 text-st-primary' },
}

export function StatusPill({ phase, className }: { phase: TripPhase; className?: string }) {
  const s = STYLES[phase]
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-st-full px-2.5 py-1 text-xs font-medium',
        s.className,
        className,
      )}
    >
      {s.dot && (
        <span className="relative flex h-2 w-2">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-st-accent opacity-70" />
          <span className="relative inline-flex h-2 w-2 rounded-full bg-st-accent" />
        </span>
      )}
      {s.label}
    </span>
  )
}
